//component
import Col from "../element/col";
import Row from "../element/row";
import Icon from "../element/icon";
import Image from "../element/image";

//assets
import { DcLogo } from "../../assets/images";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { getLanguage } from "../../redux/reducer/common.reducer";

import useWindowDimension from "../hook/use.window.dimension";

import { useTranslation } from "react-i18next";
import Dropdown from "../element/dropdown";
import HomeDeal from "../../pages/home/components/home.deal";

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isMobile, isDesktop } = useWindowDimension();
  const { language } = useSelector((state) => state.common);

  const languageList = [
    {
      label: (
        <Row className="items-center flex-nowrap gap-2">
          <Icon icon="circle-flags:lang-en" className="_svg language" />
          <p>{t("English")}</p>
        </Row>
      ),
      value: "en",
      icon: "circle-flags:lang-en",
    },
    {
      label: (
        <Row className="items-center flex-nowrap gap-2">
          <Icon icon="circle-flags:lang-ms" className="_svg language" />
          <p>{t("Malay")}</p>
        </Row>
      ),
      value: "ms",
      icon: "circle-flags:lang-ms",
    },
    {
      label: (
        <Row className="items-center flex-nowrap gap-2">
          <Icon icon="circle-flags:lang-zh" className="_svg language" />
          <p>中文</p>
        </Row>
      ),
      value: "zh",
      icon: "circle-flags:lang-zh",
    },
  ];

  const trustList = [
    {
      icon: "tdesign:secured",
      label: "No Hidden Fees",
    },
    {
      icon: "lucide:handshake",
      label: "Direct Owner",
    },
    {
      icon: "streamline-ultimate:car-3-bold",
      label: "DCAR Certified",
    },
  ];

  const navigationList = [
    { label: "Discover", path: "/" },
    { label: "Consign", path: "/consign" },
    { label: "Workshop", path: "/workshop" },
    { label: "Profile", path: "/profile", icon: "ri:account-circle-line" },
  ];

  const handleNavigate = (page) => {
    navigate(page);
  };

  if (isMobile && ["/consign", "/workshop", "/profile"].includes(pathname)) {
    return null;
  }

  const languageDropdown = (
    <Dropdown
      className="_dropdown language"
      placeholder={
        <Row className="items-center flex-nowrap gap-2">
          <Icon
            icon={
              languageList?.length > 0 &&
              languageList.find((l) => l.value == language)?.icon
            }
            className="_svg language"
          />
          <p className="_label chosen-language">{language}</p>
        </Row>
      }
      options={languageList}
      onClick={(value) => {
        localStorage.setItem("lang", value);
        dispatch(getLanguage());
      }}
    />
  );

  return (
    <header
      className={`header ${pathname === "/workshop" ? "--showroom" : ""}
      `}
    >
      {/* ${language === "ms" ? "ms" : ""} */}
      {/* ${pathname !== "/" ? "h-200" : ""} */}
      {/* The nav is desktop-only, so mobile keeps the switcher at header level. */}
      {isMobile && languageDropdown}
      <Image
        tag="section"
        src={DcLogo}
        alt="logo"
        className="_img header-logo pointer"
        onClick={() => handleNavigate("/")}
      />
      <nav className="_row navigation-list">
        {navigationList.map((item) => (
          <button
            type="button"
            className={`_button navigation-item ${
              pathname === item.path ? "active" : ""
            }`}
            key={item.path}
            onClick={() => handleNavigate(item.path)}
          >
            {item.icon && <Icon icon={item.icon} className="_svg page" />}
            <span className="_label page-label">{t(item.label)}</span>
          </button>
        ))}
        {isDesktop && languageDropdown}
      </nav>
      {isDesktop ? (
        <></>
      ) : (
        <Col>
          <h3 className="_label header-slogan">
            {t("CONSIGNMENT")} <span>{t("DIRECT OWNER")}</span>
          </h3>
          <Row className="_row trust-list">
            {trustList.map((item, index) => (
              <Row
                className={`_row trust-item ${index !== trustList.length - 1 ? "--divider" : ""}`}
                key={item.label}
              >
                <Icon
                  tag="span"
                  icon={item.icon}
                  className="_svg trust"
                  gradient
                  width={18}
                  height={18}
                />
                <p className="_label trust-label">{t(item.label)}</p>
              </Row>
            ))}
          </Row>
        </Col>
      )}

      {isMobile && <HomeDeal />}
    </header>
  );
}
